export class UTMSource {
   static get() {
      return localStorage.getItem('utm_source') || null;
   }

   static set(value: string) {
      localStorage.setItem('utm_source', value);
   }
}
